class AnalyticsService {
  constructor() {
    this.apiUrl = process.env.REACT_APP_BACKEND_URI;
    this.sessionId = this.getOrCreateSessionId();
  }

  getOrCreateSessionId() {
    let sessionId = sessionStorage.getItem('analytics_session_id');
    if (!sessionId) {
      sessionId = `session_${Date.now()}_${Math.random()
        .toString(36)
        .substr(2, 9)}`;
      sessionStorage.setItem('analytics_session_id', sessionId);
    }
    return sessionId;
  }

  async track(
    eventName,
    eventCategory,
    eventData = {},
    organizationId,
    eventInstanceId,
    sourceName = process.env.REACT_APP_FRONTEND_URI
  ) {
    try {
      const payload = {
        sessionId: this.sessionId,
        eventName,
        eventCategory,
        eventData,
        organizationId,
        eventInstanceId,
        sourceName
        // ...(organizationId && { organizationId }),
        // ...(eventInstanceId && { eventInstanceId })
      };

      const response = await fetch(`${this.apiUrl}/v1/analytics/track`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      });

      if (!response.ok) {
        console.error('Analytics tracking failed:', response.statusText);
      }
    } catch (error) {
      console.error('Analytics tracking error:', error);
    }
  }

  // Convenience methods for common events
  trackPageView(page, referrer = null, sourceName = null) {
    return this.track(
      'page_view',
      'navigation',
      {
        page,
        referrer,
        timestamp: new Date().toISOString()
      },
      undefined,
      undefined,
      sourceName
    );
  }

  trackButtonClick(buttonName, page) {
    return this.track('button_click', 'engagement', {
      buttonName,
      page,
      timestamp: new Date().toISOString()
    });
  }

  trackFormInteraction(action, formName, step = null) {
    return this.track('form_interaction', 'engagement', {
      action, // 'start', 'submit', 'error'
      formName,
      step,
      timestamp: new Date().toISOString()
    });
  }

  trackRegistrationFunnel(action, eventInstanceId, organizationId, data = {}) {
    return this.track(
      `registration_${action}`,
      'conversion',
      {
        ...data,
        timestamp: new Date().toISOString()
      },
      organizationId,
      eventInstanceId
    );
  }
}

export const analytics = new AnalyticsService();
